import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { MainPipes } from '../../pipes/main-pipes-module';

import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';

import { DossierDetailModule } from '../components/dossierDetail.module';

import { DossierHeaderModule } from '../components/dossierHeader.module';
import { DocumentFileModule } from '../../documents/documentFile/documentFile.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { TableModule } from 'primeng-lts/table';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { awardCreationComponent } from './awardCreation.component';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { A11yModule } from '@angular/cdk/a11y';
import { ButtonModule } from 'primeng-lts/button';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { MenuModule } from 'primeng-lts/menu';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { PanelModule } from 'primeng-lts/panel';
import { TabViewModule } from 'primeng-lts/tabview';
import { TooltipModule } from 'primeng-lts/tooltip';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { ToggleButtonModule } from 'primeng-lts/togglebutton';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [

    awardCreationComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DossierHeaderModule,
    DossierDetailModule,
    DocumentFileModule,
    TableModule,
    TooltipModule,
    ProgressBarModule,
    ToggleButtonModule,
    FormPlycaModule,
    PanelModule,
    TabViewModule,
    MultiSelectModule,
    MenuModule,
    ButtonModule,
    DropdownModule,
    ConfirmDialogModule,
    TranslateModule,
    MainPipes,
    WaitLoadingModule,
    DynamicDialogModule,
    SubHeaderModule,
    ScrollPanelModule,
    A11yModule,
    DirectivesModule
  ],
  entryComponents: [
    awardCreationComponent,
    formPlycaComponent
  ]
})
export class AwardCreationModule { }
